export const FULL_TABLE_TABNAME = 'leaders';

export const FULL_TABLE_CATEGORIES = {
    aflFantasyPoints: {
        category: 'Key Stats',
        column: 'dreamTeamPoints'
    },
    goals: {
        category: 'Scoring',
        column: 'goals'
    },
    disposals: {
        category: 'Disposals',
        column: 'disposals'
    },
    marks: {
        category: 'Marks',
        column: 'marks'
    },
    tackles: {
        category: 'Key Stats',
        column: 'tackles'
    },
    clearances: {
        category: 'Stoppages',
        column: 'centreClearances'
    },
    kicks: {
        category: 'Key Stats',
        column: 'kicks'
    },
    handballs: {
        category: 'Key Stats',
        column: 'handballs'
    },
    hitouts: {
        category: 'Key Stats',
        column: 'hitouts'
    }
};